<div class="tile" [class.fat-padding]="fatPadding">
  <h3 class="mb-3 font-size-3">{{ 'lombard.faqs.headline' | transloco }}</h3>
  @if (facade.faqs$ | async; as faqs) {
    @for (faq of faqs; track i; let i = $index) {
      <div class="faq">
        <div class="d-flex justify-content-between cursor-pointer no-select" (click)="toggleFaq(i)">
          {{ 'lombard.faqs.' + faq + '.teaser' | transloco }}
          <svg class="icon icon-24" [class.icon-rotate]="unfolded | includes: i" viewBox="0 0 24 24">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M4.46973 9.03034L5.53039 7.96968L12.0001 14.4393L18.4697 7.96968L19.5304 9.03034L12.0001 16.5607L4.46973 9.03034Z"
              fill="black"
            />
          </svg>
        </div>
        <div
          class="details mt-2"
          [class.active]="unfolded | includes: i"
          [innerHTML]="'lombard.faqs.' + faq + '.description' | transloco"
        ></div>
      </div>
    }
  }
</div>
